import { render, staticRenderFns } from "./TaskName.vue?vue&type=template&id=54762f5a&scoped=true&"
import script from "./TaskName.vue?vue&type=script&lang=js&"
export * from "./TaskName.vue?vue&type=script&lang=js&"
import style0 from "./TaskName.vue?vue&type=style&index=0&id=54762f5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54762f5a",
  null
  
)

export default component.exports